export default __webpack_public_path__ + "static/media/Dropbox.56e3d9cc.svg";